import React from 'react'

import style from './style.less'

export default function Maintenance() {

  return (
    <div className={style.wrapper}>
      <h4 className={style.title}>业务升级中</h4>
    </div>
  )
}
